import { type ReactNode } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import { Building2 } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { useFirmaContext } from '@/contexts/FirmaContext'
import Spinner from '@/components/Spinner'

/**
 * FirmaLoginGate – Wraps Firma-Routen.
 * Prüft Auth und löst den Firma-Token auf.
 */
export default function FirmaLoginGate({ children }: { children: ReactNode }) {
  const { firmaToken } = useParams<{ firmaToken: string }>()
  const { isAuthenticated, isLoading: authLoading, user } = useAuth()
  const { isResolving, error } = useFirmaContext()

  // Auth noch am Laden
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner />
      </div>
    )
  }

  // Nicht eingeloggt → Login
  if (!isAuthenticated || !user) {
    return <Navigate to="/portal/login" state={{ from: { pathname: `/firma/${firmaToken}` } }} replace />
  }

  // Firma-Token wird aufgelöst
  if (isResolving) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner />
      </div>
    )
  }

  // Token ungültig oder kein Zugriff
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7] px-4">
        <div className="text-center max-w-md">
          <Building2 size={48} className="mx-auto text-red-300 mb-4" />
          <h2 className="text-xl font-bold text-gray-900 mb-2">Zugriff verweigert</h2>
          <p className="text-gray-500 text-sm">{error}</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
